// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
// import { connect } from "react-redux";
import classnames from "classnames";
import { themr } from "react-css-themr";
// import { Switch, Route } from 'react-router-dom';

// ABSOLUTE PATH IMPORTS

// importing object with action creator functions
// import actions from "model/actions";
// import selectors from "model/selectors";

import CardsList from "components/emission/cards/CardsList";
import CardsListControls from "components/emission/cards/CardsListControls";
// import CardTransactionsList from "components/CardTransactionsList";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./Cards.m.scss";

@themr("cards-page", styles)
export default class Cards extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object, // object with css class names
    clientId: PropTypes.string,
    cardsData: PropTypes.object,
    cardsLoaded: PropTypes.bool,
    // action creators:
    // appReady: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedCardId: null,
    };
  }

  handleCardSelect = ({ id, value }) => {
    this.setState({ selectedCardId: value });
  };

  render() {
    const { theme, cardsData, cardsLoaded } = this.props;
    const { selectedCardId } = this.state;
    let selectedCard = null;
    let cards;
    if (cardsData && cardsData.cards && cardsData.cards.length) {
      cards = JSON.parse(JSON.stringify(cardsData.cards)).sort((a, b) => {
        if (a.cardId < b.cardId) return -1;
        if (a.cardId > b.cardId) return 1;
        return 0;
      });
      selectedCard =
        selectedCardId === null
          ? cards[0]
          : cards.find((card) => card.cardId === selectedCardId);
    }
    return (
      <div className={classnames(theme.wrapper)}>
        <div>
          <CardsList
            data={cardsData}
            cards={cards}
            selectedCard={selectedCard && selectedCard.cardId}
            changeSelected={this.handleCardSelect}
            updateQuery={cardsData.updateQuery}
          />
          <CardsListControls
            loading={cardsData && cardsData.loading}
            loaded={cardsLoaded}
            data={cardsData}
            selectedCard={selectedCard}
            updateQuery={cardsData.updateQuery}
            features={
              {
                // cardEdit:
                // roles.has("callcenter") && roles.get("callcenter").emission,
              }
            }
            refetch={cardsData ? () => cardsData.refetch() : undefined}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/Emission/Cards/Cards.js